/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  // Container,
  Input,
  Row,
  Table,
  Spinner,
} from "reactstrap";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { fetchData, _fetchApi, get_country_classification } from "./api";
import Gray from "./Gray";
import NewAverage from "./NewAverage";
// import SideBar from "./SideBar";
import UserGuide from "./UserGuide";
import WestAfricaData from "./WestAfricaData";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import moment from "moment";
export default function Dashboard({ type }) {
  // const [displayedGraph, setDisplayedGraph] = useState("Line");
  const getYearList = () => {
    const currentYear = moment().year();
    const startYear = 2002;
    const years = [];

    for (let year = currentYear; year >= startYear; year--) {
      years.push(year.toString());
    }

    return years;
  };
  const _yearList = getYearList();
  const [yearList, setYearList] = useState([]);
  const [report, setReport] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [data, setData] = useState([]);
  const [form, setForm] = useState({
    // indicator: ['Regional Indicator'],
    indicator:
      type === "World Bank"
        ? ["Real interest rate (PCT)"]
        : ["Real GDP Growth (Annual percent change)"],
    country: ["Regional Outlook"],
    year_from: "2002",
    year_to: "2022",
    region: "Sub-Saharan Africa",
    type_of_data: type,
    new_indicator: ["GDP based on PPP, share of world (Percent of World)"],
    // data_source: 'IMF',
    uemoa: "The West African Economic and Monetary Union (WAEMU)",
  });
  const [countryList, setCountryLust] = React.useState([]);
  const [indicatorList, setIndicatorList] = useState([]);
  const [indicator, setIndicator] = useState([]);
  const [indicatorByCountry, setIndicatorByCountry] = useState([]);
  const [dataByEachCountry, setdataByEachCountry] = useState([]);
  const [loading, setLoading] = useState(false);
  const [grouping, setGrouping] = useState([]);

  let [stage, setStage] = useState(1);

  let [display, setDisplay] = useState(false);
  const in_years =
    form.year_from === form.year_to
      ? 1
      : parseInt(form.year_to) - parseInt(form.year_from);
  const navigate = useNavigate();

  React.useEffect(() => {
    fetchData({ query_type: "get_countries" })
      .then((d) => {
        if (d && d.results) {
          setCountryLust([
            "Regional Outlook",
            ...d.results?.map((a) => a.country),
          ]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  React.useEffect(() => {
    setLoading(true);
    fetchData({ query_type: "get_indicators", type_of_data: form.type_of_data })
      .then((d) => {
        if (d && d.results) {
          setIndicatorList([
            // 'Regional Indicator',
            ...d.results?.map((a) => a.indicator),
          ]);
          setLoading(false);
        }
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  }, [form.type_of_data]);

  useEffect(() => {
    fetchData({
      query_type: "get_years",
    })
      .then((d) => {
        if (d && d.results) {
          setYearList(d.results?.map((a) => a.year));
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  useEffect(() => {
    get_country_classification(setGrouping);
    setCountryCon(stage > 2 ? false : true);
  }, [stage]);

  useEffect(() => {
    setLoading(true);
    if (form.country.includes("Regional Outlook")) {
      fetchData({ query_type: "by_region", ...form })
        .then((d) => {
          if (d && d.results) {
            setRawData(d.results);
            let finalData = [];

            d.results.forEach((i) => {
              finalData.push({
                name: i.indicator,
                average: i.average,
                pv: 400,
                // amt: i.amount,
              });
            });

            setReport(finalData);
          }
          setLoading(false);
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
        });
    } else {
      fetchData({ query_type: "by_country", ...form })
        .then((d) => {
          if (d && d.results) {
            setRawData(d.results);
            // console.log(d.results, "LLLLLL");
            let finalData = [];

            d.results.forEach((i) => {
              finalData.push({
                name: i.year,
                [i.indicator]: i.amount,
                // amt: i.amount,
              });
            });

            setReport(finalData);
          }
          setLoading(false);
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
        });
    }
  }, [form]);

  const handleChange = ({ target: { name, value } }) =>
    setForm((p) => ({ ...p, [name]: value }));

  const getRegionalAverage = useCallback(() => {
    setLoading(true);
    fetchData({ query_type: "regional_average", ...form })
      .then((d) => {
        if (d && d.results) {
          setRawData(d.results);
          let finalData = [];

          d.results.forEach((i) => {
            finalData.push({
              name: i.country,
              [i.indicator]: i.amount,
              // amt: i.amount,
            });
          });

          setReport(finalData);
          setLoading(false);
        }
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  }, [form]);

  const get_weighted_average = useCallback(() => {
    setLoading(true);
    _fetchApi(
      `/query-data?query_type=weighted_average&year_from=${form.year_from}&year_to=${form.year_to}&data_source=${form.data_source}&uemoa=${form.uemoa}`,
      (d) => {
        setData(d.results);
        setLoading(false);
        console.log(d);
      },
      (err) => {
        console.log(err);
        setLoading(false);
      }
    );
  }, [form.year_from, form.year_to, form.data_source, form.uemoa]);

  const get_by_indicator = useCallback(() => {
    setLoading(true);
    _fetchApi(
      `/get_by_indicator?query_type=indicator&year_from=${form.year_from}&year_to=${form.year_to}&type_of_data=${type}&data_source=${form.data_source}&uemoa=${form.uemoa}`,
      (d) => {
        setIndicator(d.results);
        setLoading(false);
        console.log(d);
      },
      (err) => {
        console.log(err);
        setLoading(false);
      }
    );
  }, [form.year_from, form.year_to, type, form.data_source, form.uemoa]);

  const get_by_indicatorCountry = useCallback(() => {
    setLoading(true);
    _fetchApi(
      `/get_by_indicator?query_type=by_country&year_from=${form.year_from}&year_to=${form.year_to}&indicator=${form.indicator}&in_years=${in_years}&data_source=${form.data_source}&uemoa=${form.uemoa}`,
      (d) => {
        setIndicatorByCountry(d.results);
        console.log(d);
        setLoading(false);
      },
      (err) => {
        console.log(err);
        setLoading(false);
      }
    );
  }, [
    form.year_from,
    form.year_to,
    form.indicator,
    in_years,
    form.data_source,
    form.uemoa,
  ]);

  const get_by_Average_by_country = useCallback(() => {
    setLoading(true)
    _fetchApi(
      `/query-data?query_type=by_indicator_country&year_from=${form.year_from}&year_to=${form.year_to}&country=${form.country}&region=${form.region}&type_of_data=${form.type_of_data}&indicator=${form.indicator}&data_source=${form.data_source}&uemoa=${form.uemoa}`,
      (d) => {
        setdataByEachCountry(d.results);
         setLoading(false);
      },
      (err) => {
        console.log(err);
        setLoading(false);
      }
    );
  }, [
    form.year_from,
    form.year_to,
    form.country,
    form.type_of_data,
    form.region,
    form.indicator,
    form.data_source,
    form.uemoa,
  ]);

  useEffect(() => {
    get_weighted_average();
    get_by_indicatorCountry();
    get_by_indicator();
    get_by_Average_by_country();
    getRegionalAverage();
  }, [
    get_weighted_average,
    get_by_indicator,
    get_by_indicatorCountry,
    get_by_Average_by_country,
    getRegionalAverage,
  ]);
  const stageOne = stage === 1;

  const [countryCon, setCountryCon] = useState(
    form.country.includes("Regional Outlook")
  );

  let newArr = stageOne
    ? indicator
    : !countryCon
    ? dataByEachCountry
    : indicatorByCountry;
  const { country, year_from, year_to, region } = form;
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  let fileName = `${form.indicator} ${country} ${region} ${year_from} - ${year_to}`;
  const exportToCSV = () => {
    const ws = XLSX.utils.json_to_sheet(newArr);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <>
      <div className="d-flex align-items-center">
        {/* <small>{JSON.stringify({ countryCon, form: form })}</small> */}
        {stage === 1 ? null : (
          <Button
            onClick={() =>
              stage < 2 ? setCountryCon(true) : setStage(stage - 1)
            }
            color="warning"
            className="m-2"
          >
            Go back
          </Button>
        )}
        {/* <Button
          // onClick={() => getRegionalAverage()}
          onClick={() => setDisplay(false)}
          color={!display ? "primary" : "secondary"}
          className="m-2"
        >
          Regional Average
        </Button>
        <Button
          className="m-2"
          color={display ? "primary" : "secondary"}
          onClick={() => setDisplay(true)}
        >
          Weighted Average
        </Button>
        <Button className="m-2" color="success" onClick={() => exportToCSV()}>
          Download in Excel
        </Button> */}

        {/* <div className="col-md-2">
          <Input type="select" onChange={({target:{value}}) => setForm(p => ({ ...p, data_source: value}))}>
            <option value={'IMF'}>IMF</option>
            <option value={'World Bank'}>World Bank</option>
          </Input>
        </div> */}
      </div>

      <Row>
        <Col md={9}>
          <CardBody>
            {loading && (
              <div className="text-center">
                <Spinner /> Loading...
              </div>
            )}
            <Row>
              <Col md={6}>
                {/* {!stageOne && !display && ( */}
                <>
                  <label className="text-white">Select Indicator</label>
                  <Input
                    type="select"
                    value={form.indicator}
                    name="indicator"
                    onChange={({ target: { value } }) =>
                      setForm((p) => ({ ...p, indicator: [value] }))
                    }
                  >
                    {indicatorList?.map((indicator, id) => (
                      <option key={id} value={indicator}>
                        {indicator}
                      </option>
                    ))}
                  </Input>
                </>
                {/* )} */}
              </Col>
              <div className="col-md-6">
                {/* <label>UEMOA</label> */}
                <label className="text-white">Country Classification</label>
                <Input
                  type="select"
                  value={form.uemoa}
                  name="uemoa"
                  onChange={({ target: { value } }) => {
                    setForm((p) => ({ ...p, uemoa: value }));
                    // getQueryParams('uemoa', value)
                  }}
                >
                  {grouping?.map((indicator, id) => (
                    <option key={id} value={indicator.grouping}>
                      {indicator.grouping}
                    </option>
                  ))}
                </Input>
              </div>
              {/* <Col md={6}>
                {!stageOne && !display && (
                  <>
                    <label className="text-white">Select Country</label>
                    <Input
                      type="select"
                      value={form.country}
                      name="country"
                      onChange={handleChange}
                    >
                      {countryList?.map((country, id) => (
                        <option key={id} value={country}>
                          {country}
                        </option>
                      ))}
                    </Input>
                  </>
                )}
              </Col> */}
            </Row>
            <Card className="p-3 mt-3">
              <h3 className="text-center">
                {stageOne
                  ? "Sub-Saharan Africa economic outlook regional Average per indicator"
                  : form.indicator}{" "}
                - {form.country} ({form.year_from} - {form.year_to})
              </h3>

              {/* <Gray report={report} indicator={form.indicator} /> */}
            </Card>
          </CardBody>

          <div>
            {display ? (
              <NewAverage
                year_from={form.year_from}
                year_to={form.year_to}
                indicator={form.indicator}
                type_of_data={form.type_of_data}
                setForm={setForm}
                new_indicator={form.new_indicator}
                data_source={form.data_source}
                uemoa={form.uemoa}
                grouping={grouping}
              />
            ) : (
              <WestAfricaData
                setForm={setForm}
                yearList={yearList}
                handleChange={handleChange}
                rawData={data}
                stageOne={stageOne}
                newArr={newArr}
                setStage={setStage}
                stage={stage}
                form={form}
                countryCon={!countryCon}
                grouping={grouping}
                loading={loading}
              />
            )}
          </div>
          {!stageOne ? (
            countryCon ? (
              <Card
                body
                className="p-3 mt-3"
                style={{ height: "70vh", overflow: "auto" }}
              >
                <BarChart
                  width={1000}
                  height={380}
                  data={newArr?.map((a) => ({
                    ...a,
                    country: `${a["country"].slice(0, 5)}..`,
                    "Simple Average": a["average"],
                  }))}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="country" angle={-45} />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="Simple Average" fill="#8884d8" />
                </BarChart>
              </Card>
            ) : (
              // <Gray
              //   report={
              //     newArr
              //     //   .map((a) => ({
              //     //   ...a,
              //     //   indicator: `${a['indicator'].slice(0, 5)}...`,
              //     // }))
              //   }
              //   // report={form.country[0] === "Regional Outlook" ? data : newArr}
              //   indicator={form.indicator}
              //   stageOne={stageOne}
              //   xAngle={-45}
              // />
              <Card
                body
                className="p-3 mt-3"
                style={{ height: "70vh", overflow: "auto" }}
              >
                <h5 className="text-center mb-2">
                  {newArr && newArr.length ? newArr[0].indicator : ""}
                </h5>
                <LineChart
                  width={900}
                  height={380}
                  data={newArr?.map((a) => ({
                    ...a,
                    Total: a["amt"],
                  }))}
                  margin={{
                    top: 5,
                    // right: 30,
                    // left: 50,
                    // bottom: 50,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey={"year"} angle={-45} textAnchor="end" />
                  <YAxis />
                  <Tooltip />
                  <Legend />

                  {/* {indicator.map((ind, i) => ( */}
                  <Line
                    type="monotone"
                    dataKey={"Total"}
                    stroke="#8884d8"
                    fill="#8884d8"
                    line={false}
                  />
                  {/* ))} */}
                </LineChart>
              </Card>
            )
          ) : null}
        </Col>
        <Col md={3}>
          {/* <small>{JSON.stringify(yearList)}</small> */}
          <label className="text-white">Period</label>
          <Row className="mb-3">
            <Col md={6} className="m-0 pe-1">
              <Input
                type="select"
                value={form.year_from}
                name="year_from"
                onChange={handleChange}
              >
                {_yearList?.map((year, id) => (
                  <option key={id} value={year}>
                    {year}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={6} className="m-0 ps-1">
              <Input
                type="select"
                value={form.year_to}
                name="year_to"
                onChange={handleChange}
              >
                {yearList?.map((indicator, id) => (
                  <option key={id} value={indicator}>
                    {indicator}
                  </option>
                ))}
              </Input>
            </Col>
          </Row>
          <UserGuide stage={stage} />
          {/* <SideBar
            form={indicatorByCountry}
            setForm={setForm}
            yearList={yearList}
            handleChange={handleChange}
            rawData={data}
            stageOne={stageOne}
            newArr={newArr}
            setStage={setStage}
            stage={stage}
          /> */}
        </Col>
      </Row>
    </>
  );
}
